import "office-ui-fabric-react/dist/css/fabric.min.css";
import * as React from "react";
import * as ReactDOM from "react-dom";
import Progress from "./components/Progress";
import { AppContainer } from "react-hot-loader";
import { UIStrings } from "./loc/UIStrings";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import { ISofaTaskPaneStrings } from "./loc/myStrings.model";
import AgendaApp from "./components/AgendaApp";
import HostType = Office.HostType;
import { initialToken } from "./enums";
import PlatformType = Office.PlatformType;
/* global AppContainer, Component, document, Office, OfficeRuntime, module, require */

initializeIcons();

let isOfficeInitialized = false;
let token = initialToken;
let strings: ISofaTaskPaneStrings | {} = {};
let platform: PlatformType = PlatformType.Universal;

const render = (Component) => {
  ReactDOM.render(
    <AppContainer>
      <Component token={token} isOfficeInitialized={isOfficeInitialized} strings={strings} platform={platform} />
    </AppContainer>,
    document.getElementById("agendaContainer")
  );
};

const getAuthToken = async () => {
  try {
    return await OfficeRuntime.auth.getAccessToken({
          allowSignInPrompt: true,
          allowConsentPrompt: true,
          forMSGraphAccess: true
      });
  } catch (e) {
    console.error(e);
    return "";
  }
};

const fetchInitialData = async (siteToken: string) => {
  token = siteToken || "";
  isOfficeInitialized = !!siteToken;
  platform = Office.context.platform;
};

const fetchStrings = () => {
  const locale = Office.context.displayLanguage;
  strings = UIStrings.getLocaleStrings(locale);
};

/* Render application after Office initializes */
Office.initialize = async () => {
  render(Progress);
  fetchStrings();
  const siteToken =
      initialToken ||
      await getAuthToken();

  await fetchInitialData(siteToken);
  if (Office.context.host === HostType.Excel) {
    await Excel.run(function (ctx) {
      ctx.workbook.properties;
      return ctx.sync().then(function () {
        render(AgendaApp);
      });
    }).catch(function (error) {
      if (error instanceof OfficeExtension.Error) {
        const warningTitle = UIStrings.getLocaleStrings(Office.context.displayLanguage).errorTitle;
        ReactDOM.render(
          <AppContainer>
            <div className={"errorMessage"}>
              <h2>{warningTitle}</h2>
              <p>{error.message}</p>
            </div>
          </AppContainer>,
          document.getElementById("agendaContainer")
        );
      }
    });
  } else {
    render(AgendaApp);
  }
};

if ((module as any).hot) {
  (module as any).hot.accept("./components/AgendaApp", () => {
    const NextApp = require("./components/AgendaApp").default;
    render(NextApp);
  });
}
